import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

const state = () => ({
    waterSitesCount: 1,
    waterSites: [
        {
            spidLookup: null,
            spid: null,
            address: {
                street: null,
                town: null,
                country: null,
                postcode: null,
            },
            quoteToolUsable: null,
            usage: null,
            frequency: 'annually',
            customerReferenceNumber: null,
            isBillingSite: null,
        }
    ],
    useCustomBillingAddress: false,
    customBillingAddress: {
        lookupAddress: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        city: null,
        province: null,
        postcode: null,
    },
    confirmationReceived: null,
})

const getters = {
    getField,

    continueQuoteToolJourney: state => {
        for (let siteId = 0; siteId < state.waterSites.length; siteId++) {
            if (state.waterSites[siteId].quoteToolUsable == false) {
                return false;
            }
        }

        if (state.waterSitesCount == 6) {
            return false;
        }

        return true;
    }
}

const actions = {
    fetchSPID({ commit, rootState, state }, siteIndex) {
        return new Promise((resolve, reject) => {
            const spid = state.waterSites[siteIndex].spidLookup;
            const key = rootState.informationStep.key;

            axios.get('/quotetoolapi/quote/getspiddata', {
                params: {
                    spid: spid,
                }
            }).then(response => {
                const payload = {
                    key,
                    spid: response.data.spid,
                    address: {
                        street: response.data.address.street,
                        town: response.data.address.town,
                        country: response.data.address.county,
                        postcode: response.data.address.postcode,
                    },
                    quoteToolUsable: response.data.quoteToolUsable,
                    usage: response.data.estimatedConsumption,
                }

                commit('updateSpidData', { response: payload, siteIndex });

                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    getQuotes({ commit, rootState, state }) {
        return new Promise((resolve, reject) => {
            const url = '/quotetoolapi/quote/getquotes';
            const key = rootState.informationStep.key;

            let billingAddress = {};

            if (state.useCustomBillingAddress) {
                const { addressLine1, addressLine2, addressLine3, city, province, postcode } = state.customBillingAddress;

                let street = addressLine1;

                if (addressLine2 !== '') {
                    street += ' ' + addressLine2;
                }

                if (addressLine3 !== '') {
                    street += ' ' + addressLine3;
                }

                billingAddress = {
                    street,
                    town: city,
                    county: province,
                    postcode: postcode
                }
            } else {
                const [billingSite] = state.waterSites.filter(site => site.isBillingSite);

                if (billingSite != undefined) {
                    billingAddress = Object.assign({}, billingSite.address);
                }
            }

            if (Object.keys(billingAddress).length > 0) {
                const payload = {
                    key,
                    sites: state.waterSites.map(site => ({
                        spid: site.spid,
                        estimatedConsumption: site.usage,
                        customerReferenceNumber: site.customerReferenceNumber,
                        estimatedConsumptionFrequency: site.frequency
                    })),
                    billingAddress,
                };

                axios.post(url, payload).then((response) => {

                    if (response.data.quote == null) {
                        commit('stepProgress/updateDropoutConfirmationStep', null, { root: true });

                    } else {
                        commit('quoteStep/updateQuoteData', response.data.quote, { root: true });
                        commit('stepProgress/toggleStep', null, { root: true });
                    }

                    resolve();

                }).catch(error => {
                    reject(error);
                })
            } else {
                reject('ADDRESS_MISSING');
            }

        })
    },
}

const mutations = {
    updateField,

    addWaterSites(state, count) {
        const waterSiteModel = {
            spidLookup: null,
            spid: null,
            address: {
                street: null,
                town: null,
                country: null,
                postcode: null,
            },
            quoteToolUsable: null,
            usage: null,
            frequency: 'annually',
            customerReferenceNumber: null,
            isBillingSite: null,
        };

        for (let countIndex = 0; countIndex < count; countIndex++) {
            state.waterSites.push(Object.assign({}, waterSiteModel));
        };
    },

    removeWaterSites(state, count) {
        state.waterSites.splice(-1 * count);
    },

    updateSpidData(state, { response, siteIndex }) {
        state.waterSites[siteIndex] = Object.assign(state.waterSites[siteIndex], response);
    },

    updateSite(state, { site, index }) {
        state.waterSites[index] = Object.assign(state.waterSites[index], site);
    },

    resetCustomBillingAddress(state) {
        state.useCustomBillingAddress = false;
        state.customBillingAddress = Object.assign({}, {
            lookupAddress: null,
            addressLine1: null,
            addressLine2: null,
            addressLine3: null,
            city: null,
            province: null,
            postcode: null,
        });
    },

    resetSitesBilling(state) {
        state.waterSites = state.waterSites.map(site => {
            site.isBillingSite = false;

            return site;
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}